/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import React from 'react';

type CancelCompleteProps = {
  isOpen: boolean;
  onClose: () => void;
  shopName: string;
  courseName: string;
  date: string;
  time: string;
};

export const CancelComplete: React.FC<CancelCompleteProps> = ({
  isOpen,
  onClose,
  shopName,
  courseName,
  date,
  time,
}) => {
  if (!isOpen) return null;

  return (
    <div css={styles.container}>
      <div css={styles.content}>
        <div css={styles.iconWrapper}>
          <CheckCircleOutlineIcon css={styles.icon} />
        </div>
        <h2 css={styles.title}>予約の取り消しが完了しました</h2>
        <div css={styles.reservationInfo}>
          <div css={styles.shopName}>{shopName}</div>
          <div css={styles.courseName}>{courseName}</div>
          <div css={styles.dateTime}>
            {date} {time}
          </div>
        </div>
        <button css={styles.closeButton} onClick={onClose}>
          閉じる
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  `,
  content: css`
    max-width: 400px;
    width: 100%;
    text-align: center;
  `,
  iconWrapper: css`
    margin-bottom: 24px;
  `,
  icon: css`
    color: #4caf50;
    &.MuiSvgIcon-root {
      width: 120px;
      height: 120px;
    }
  `,
  title: css`
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 24px;
    color: #333;
    line-height: 1.5;
  `,
  reservationInfo: css`
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 32px;
  `,
  shopName: css`
    font-size: 14px;
    color: #666;
    margin-bottom: 4px;
  `,
  courseName: css`
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  `,
  dateTime: css`
    font-size: 16px;
    color: #666;
  `,
  closeButton: css`
    width: 100%;
    padding: 16px 24px;
    border: 2px solid #333;
    background-color: white;
    color: #333;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
      background-color: #f5f5f5;
    }
  `,
};
